import React from 'react';

export default function ConnectorPasswordField({
  id,
  label,
  value,
  onChange,
  disabled = false,
  revealed = false,
  onToggleReveal,
  placeholder = '',
}) {
  const labelId = `${id}-label`;
  return (
    <div className="connector-openvas-field">
      <span className="ghost-exposure-sys-field-label" id={labelId}>
        {label}
      </span>
      <div className="connector-openvas-password-wrap">
        <input
          id={id}
          type={revealed ? 'text' : 'password'}
          className="ghost-exposure-sys-input connector-openvas-input--password"
          placeholder={placeholder}
          autoComplete="new-password"
          aria-labelledby={labelId}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
        />
        <button
          type="button"
          className="connector-openvas-password-toggle"
          onClick={onToggleReveal}
          disabled={disabled}
          aria-label={revealed ? `Hide ${label}` : `Show ${label}`}
          aria-pressed={revealed}
        >
          {revealed ? (
            <svg className="connector-openvas-password-toggle-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
              <circle cx="12" cy="12" r="3" />
            </svg>
          ) : (
            <svg className="connector-openvas-password-toggle-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
              <line x1="1" y1="1" x2="23" y2="23" />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
}
